// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"2fc80404","335":"05ca9e34","799":"55374741"}[chunkId] + ".chunk.css";
};